import AppConfig from "../../app.config";
import { toasts } from "svelte-toasts";
import { changeSessionState } from "../Stores/Session";
import { LATEST_PURCHASE } from "../Stores/Purchase";
export default class Session {
    static async auth(phone, pin) {
        const body = new URLSearchParams();
        body.append("phone", phone);
        body.append("pin", pin);
        const res = await fetch(`${AppConfig.REST.URL}/session/auth`, { method: 'POST', body });
        const json = await res.json();
        if (json.token) {
            toasts.success(`Sukces`, `Zalogowano pomyślnie!`);
            changeSessionState(true);
        }
        if (res.status == 401) {
            toasts.error(`Uwaga`, `Podane dane logowania są nieprawidłowe - sprawdź je i spróbuj ponownie.`);
        }
        return json;
    }
    static getToken() {
        const token = localStorage.getItem('fidrygalki_token');
        if (token)
            changeSessionState(true);
        return token ? token : null;
    }
    static getDebugType() {
        const paramsString = window.location.href.split('?')[1];
        const searchParams = new URLSearchParams(paramsString);
        return searchParams.get('debug');
    }
    static isDebug() {
        const paramsString = window.location.href.split('?')[1];
        const searchParams = new URLSearchParams(paramsString);
        return searchParams.has('debug');
    }
    static logout() {
        localStorage.removeItem('fidrygalki_token');
        changeSessionState(false);
        LATEST_PURCHASE.set(null);
        toasts.info(`Informacja`, `Wylogowano z aplikacji.`);
        window.location.replace('/#/auth');
    }
}
